/**
 * @module ViewControls
 */
import { Button, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import { useRepository } from '@sensenet/hooks-react';
import React, { createElement, useEffect, useState } from 'react';
import { isFullWidthField } from "../helpers.js";
import { reactControlMapper } from "../react-control-mapper.js";
/**
 * Interface for BrowseView properties
 */

const useStyles = makeStyles(() => {
  return createStyles({
    grid: {},
    fieldWrapper: {},
    field: {},
    fieldFullWidth: {},
    actionButtonWrapper: {
      textAlign: 'right'
    },
    cancel: {}
  });
});

/**
 * View Control for browsing a Content, works with a single Content and based on the ReactControlMapper
 */
export const BrowseView = props => {
  var _props$localization, _props$localization2;

  const controlMapper = props.controlMapper || reactControlMapper(props.repository);
  const [schema, setSchema] = useState(controlMapper.getFullSchemaForContentType(props.content.Type, 'browse'));
  const classes = useStyles(props);
  const repository = useRepository();
  useEffect(() => {
    const schemaObservable = repository.schemas.subscribeToSchemas(() => {
      setSchema(() => controlMapper.getFullSchemaForContentType(props.content.Type, 'browse'));
    });
    return () => schemaObservable.dispose();
  }, [repository.schemas, props.content.Type, controlMapper]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.renderTitle ? props.renderTitle() : /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, schema.schema.DisplayName), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.grid
  }, schema.fieldMappings.sort((item1, item2) => (item2.fieldSettings.FieldIndex || 0) - (item1.fieldSettings.FieldIndex || 0)).map(field => {
    const isFullWidth = isFullWidthField(field, props.content, repository);
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      key: field.fieldSettings.Name,
      className: classes.fieldWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: isFullWidth ? classes.fieldFullWidth : classes.field
    }, /*#__PURE__*/createElement(controlMapper.getControlForContentField(props.content.Type, field.fieldSettings.Name, 'browse'), {
      actionName: 'browse',
      settings: field.fieldSettings,
      content: props.content,
      fieldValue: props.content[field.fieldSettings.Name],
      renderIcon: props.renderIcon,
      repository: props.repository,
      localization: props.fieldLocalization,
      locale: props.locale
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": ((_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.close) || 'Close',
    color: "default",
    className: classes.cancel,
    onClick: () => {
      var _props$handleCancel;

      return (_props$handleCancel = props.handleCancel) === null || _props$handleCancel === void 0 ? void 0 : _props$handleCancel.call(props);
    }
  }, ((_props$localization2 = props.localization) === null || _props$localization2 === void 0 ? void 0 : _props$localization2.close) || 'Close')));
};
//# sourceMappingURL=browse-view.js.map